const ULTRA_LOW = "ultra_low";
const LOW = "low";
const MEDIUM = "medium";
const HIGH = "high";
const CUSTOM = "custom";

const risks = {
  [ULTRA_LOW]: {
    color: "info",
    hideSmall: true,
  },
  [LOW]: {
    color: "primary",
  },
  [MEDIUM]: {
    color: "default",
  },
  [HIGH]: {
    color: "danger",
    proOnly: true,
  },
  [CUSTOM]: {
    color: "dark",
    proOnly: true,
  },
};

interface RiskOption {
  value: string;
  name?: string;
}

interface StrategyWithConfig {
  name?: string;
  configOptions?: {
    riskOptions?: RiskOption[];
    [key: string]: unknown;
  } | null;
  [key: string]: unknown;
}

const getStrategyName = (strategy: StrategyWithConfig | null | undefined, risk: string | null | undefined) => {
  if (!strategy || !risk) return "--------";
  else return strategy?.configOptions?.riskOptions?.find((r: RiskOption) => r.value === risk)?.name || strategy?.name;
  // return `
  //   ${risk?.name || t(configRisk).toUpperCase()}
  //   ${risk?.name ? ` | ${t("risk", { risk: t(configRisk) })}` : ""}
  // `
};

export { getStrategyName, risks };
export default risks;
